import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import bg from '../assets/images/hero/auth.jpg'
import logo from '../assets/images/branding/logo-hap.svg'
import { clearUser, clearMember } from '../slices/authSlice';
import useCsrfToken from '../hooks/useCsrfToken'

export default function Logout() {
    const { csrfToken } = useCsrfToken();
    const dispatch = useDispatch();
    useEffect(() => {
        if (!csrfToken) {
            return;
        }
        const API_URL = process.env.REACT_APP_API_URL;
        try {
            fetch(`${API_URL}/api/arandaplus/logout`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                }
            }).then(response => {
                return response.json();
            }).then(data => {
                if (data.status === 'success') {
                    dispatch(clearUser());
                    dispatch(clearMember());
                }
            }).catch(error => {
                console.error('Error fetching logout:', error);
                dispatch(clearUser());
                dispatch(clearMember());
            });
        } catch (error) {
            console.error('Error fetching logout:', error);
            dispatch(clearUser());
            dispatch(clearMember());
        }
    }, [dispatch, csrfToken]);

    return (
        <>
            <section className="bg-home d-flex align-items-center" style={{ backgroundImage: `url(${bg})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-linear-gradient-2"></div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="p-4 bg-white rounded shadow-md mx-auto w-100" style={{ maxWidth: '400px' }}>
                                <Link to="/"><img src={logo} className="mb-4 d-block mx-auto w-50 p-2" alt="" /></Link>
                                <h6 className="mb-3 text-uppercase fw-semibold text-center">Ha salido de su cuenta</h6>

                                <div className="text-center">
                                    <Link to="/" className="btn btn-primary">Volver a Home</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
